import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { TenantDto, SubscriptionDto } from '@stores/tenants/models/tenant.model';

export const ConsoleActions = createActionGroup({
  source: 'Console',
  events: {
    'Set Selected Tenant': props<{ tenant: TenantDto | null }>(),
    'Set Selected Subscription': props<{ subscription: SubscriptionDto | null }>(),
    'Clear Selections': emptyProps(),
  },
});
